import React from 'react'
import { DeliveryMethod, PaymentMethod } from '@dustin-web/microsite-config/src/site-context'
import { PaymentMethodIcon } from './payment-method-icon'
import { DeliveryMethodIcon } from './delivery-method-icon'
import { FooterCertificates } from './footer-certificates'
import { FlagLink } from './flag-link'

type FooterDeliveryPaymentsProps = {
  site: string
  deliveryMethods: DeliveryMethod[]
  paymentMethods: PaymentMethod[]
  translate: (key: string) => string
}

export const FooterDeliveryPayments = ({
  site,
  deliveryMethods,
  paymentMethods,
  translate,
}: FooterDeliveryPaymentsProps) => {
  return (
    <>
      <div className="content-area-payments">
        <div className="flex-sm-row flex-md-column flex-lg-row u-mb-lg-0 d-sm-flex flex-sm-wrap">
          <div className="u-mb-8 u-mb-sm-24 u-mr-sm-32 u-mr-md-0 u-mr-lg-32 content-area-payments--content-area">
            <p className="u-mb-8 u-mb-md-12">{translate('PaymentOptions')}</p>
            <div className="d-flex flex-wrap flex-row align-items-center content-area-payments--payment-methods">
              {paymentMethods.map((item: any, index: number) => (
                <PaymentMethodIcon
                  key={index}
                  item={item}
                  className={index < paymentMethods.length - 1 ? 'u-mr-16' : ''}
                  translate={translate}
                />
              ))}
            </div>
          </div>
          <div className="u-mb-16 u-mb-sm-32">
            <p className="u-mb-8 u-mb-md-12">{translate('DeliveryOptions')}</p>
            <div
              className="d-flex flex-row flex-sm-wrap align-items-center"
              style={{ minHeight: 32 }}>
              {deliveryMethods.map((item: any, index: number) => (
                <DeliveryMethodIcon
                  key={index}
                  item={item}
                  className={index < paymentMethods.length - 1 ? 'u-mr-16' : ''}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="content-area-safety align-items-start u-mr-md-0 u-mr-lg-0 flex-wrap">
        <div className="content-area-safety--content-area flex-column u-mb-8 u-mb-sm-24 u-mr-md-0 u-mr-lg-0">
          <div>
            <p className="u-mb-8 u-mb-md-12">{translate('SafeShopping')}</p>
            <div className="d-flex flex-lg-row">
              <FooterCertificates site={site} />
            </div>
          </div>
        </div>
        <div className="content-area-safety--countries">
          <div style={{ flex: '180px 0 0' }}>
            <p className="u-mb-8 u-mb-md-12">{translate('ChooseCountry_Footer')}</p>
            <FlagLink country={'SWE'} />
            <FlagLink country={'NOR'} />
            <FlagLink country={'DNK'} />
            <FlagLink country={'FIN'} />
            <FlagLink country={'NLD'} />
            <FlagLink country={'BEL'} last />
          </div>
        </div>
      </div>
    </>
  )
}
